/** Ported from haulsheet index.html ocrParseBennett (Bennett available-loads table). */
import { OCR_EQUIP, ocrBennettDim, ocrBlankLoad, ocrIsState, ocrNum, ocrTitle, } from "./shared.js";
export function ocrParseBennett(lines) {
    const dateRe = /^\d{2}\/\d{2}\/\d{2}$/;
    const anchors = lines.filter((l) => {
        const d = l.words.filter((w) => dateRe.test(w.t));
        return (d.length === 2 &&
            l.words.filter((w) => w.x > d[1].x && /^[\d.,]+$/.test(w.t)).length >= 4);
    });
    if (!anchors.length)
        return [];
    const allWords = [];
    for (const l of lines)
        for (const w of l.words)
            allWords.push(w);
    return anchors.map((a, i) => {
        const L = ocrBlankLoad();
        const prev = anchors[i - 1];
        const next = anchors[i + 1];
        const gap = next ? next.cy - a.cy : prev ? a.cy - prev.cy : a.words[0].h * 5;
        const top = prev ? (prev.cy + a.cy) / 2 : a.cy - gap / 2;
        const bot = next ? (next.cy + a.cy) / 2 : a.cy + gap / 2;
        const band = allWords
            .filter((w) => {
            const cy = w.y + w.h / 2;
            return cy > top && cy < bot;
        })
            .sort((p, q) => {
            const dy = p.y + p.h / 2 - (q.y + q.h / 2);
            return Math.abs(dy) > p.h * 0.6 ? dy : p.x - q.x;
        });
        const dates = a.words.filter((w) => dateRe.test(w.t));
        const order = a.words.filter((w) => /^\d{7}$/.test(w.t) && w.x < dates[0].x)[0];
        const head = band
            .filter((w) => w.x < (order ? order.x : dates[0].x) && /^[A-Z]{2,3}$/.test(w.t))
            .sort((p, q) => p.x - q.x);
        const eq = head[0] ? head[0].t : "";
        const term = head[1] ? head[1].t : "";
        L.equipment = eq ? OCR_EQUIP[eq] || eq + " (Bennett code)" : "";
        const nums = a.words.filter((w) => w.x > dates[1].x && /^[\d.,]+$/.test(w.t));
        const keys = ["miles", "weight", "length", "width", "height", "gross"];
        const v = {};
        keys.forEach((k, n) => {
            v[k] = nums[n] ? nums[n].t : "";
        });
        if (nums.length !== 6) {
            L.unreadable.push("Expected 6 numbers after the dates (miles, weight, length, width, height, gross) but read " +
                nums.length +
                ". Check them all");
        }
        L.miles = ocrNum(v.miles);
        L.weight = ocrNum(v.weight);
        L.length = ocrBennettDim(v.length, "Length", L);
        L.width = ocrBennettDim(v.width, "Width", L);
        L.height = ocrBennettDim(v.height, "Height", L);
        L.linehaul = "";
        if (v.gross) {
            L.notes =
                (L.notes ? L.notes + " " : "") +
                    "Est. B/R Gross on board: " +
                    v.gross +
                    " (not used as linehaul).";
        }
        const lastNum = nums[nums.length - 1];
        const places = band
            .filter((w) => w.x > (order ? order.x + order.w : 0) &&
            w.x + w.w < dates[0].x &&
            (/,/.test(w.t) || /^[A-Z][A-Z.'\-]{2,}$/.test(w.t)) &&
            !/^\(?FR[TI]\)?$/.test(w.t))
            .map((w) => w.t)
            .join(" ");
        let m;
        const re = /([A-Z][A-Z .'\-]*?)\s*[,.]\s*([A-Z]{2})\b/g;
        const found = [];
        while ((m = re.exec(places))) {
            if (ocrIsState(m[2]))
                found.push(ocrTitle(m[1].trim()) + ", " + m[2]);
        }
        L.origin = found[0] || "";
        L.destination = found[1] || "";
        if (found.length === 1) {
            const cut = places.search(/[A-Z][A-Z .'\-]*?\s*[,.]\s*[A-Z]{2}\b(?![\s\S]*[,.]\s*[A-Z]{2}\b)/);
            const lead = cut > 0 ? places.slice(0, cut).replace(/[^A-Za-z]+$/, "").trim() : "";
            if (lead) {
                L.destination = found[0];
                L.origin = ocrTitle(lead);
            }
        }
        if (found.length !== 2) {
            L.unreadable.push('Origin and destination read as "' + places + '": check them');
        }
        L.commodity = lastNum
            ? ocrTitle(band
                .filter((w) => w.x > lastNum.x + lastNum.w && /[A-Za-z]/.test(w.t))
                .map((w) => w.t)
                .join(" "))
            : "";
        L.pickup = dates[0].t + " (early pickup date)";
        L.delivery = dates[1].t + " (late delivery date)";
        L.ref =
            "Bennett order " +
                (order ? order.t : "?") +
                (term ? ", terminal " + term : "");
        if (!order)
            L.unreadable.push("Order number could not be read");
        L.unreadable.push("No posted rate on this Bennett table row — Est. B/R Gross is not linehaul");
        L.unreadable.push("Tarp requirement and special instructions are not on this table");
        L.notes = (L.notes ? L.notes + " " : "") + "No deadhead shown on this table.";
        L._cy = a.cy;
        return L;
    });
}
//# sourceMappingURL=bennett.js.map